import { render, staticRenderFns } from "./TableGoods.vue?vue&type=template&id=e0a844c2&"
import script from "./TableGoods.vue?vue&type=script&lang=js&"
export * from "./TableGoods.vue?vue&type=script&lang=js&"
import style0 from "./TableGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tag: require('/home/runner/work/myody_front/myody_front/components/tag/Tag.vue').default})
